import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhonelinkRingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phonelink_ring"}/>
}
